import {DependencyInjectId} from '@@/package/const/DependencyInjectId';
import {CourseHelper} from "@@/package/mapper/course/CourseHelper";
import CourseApi from "@@/package/apis/course/CourseApi";
import {type ApplicationContextInterface} from "@@/package/application/applicationContext";
import {MyCourseListModel} from "~~/package/mapper/course/model/MyCourseListModel";
import {CourseDetailModel} from "~~/package/mapper/course/model/CourseDetailModel";
import type CourseRecentlyResponse from "~~/package/apis/course/response/CourseRecentlyResponse";
import type CustomResponse from "~~/package/types/ResponseType";

export default class CourseMapper {

    protected courseApi: CourseApi;
    constructor(context: ApplicationContextInterface) {
        this.courseApi =  context.getService<CourseApi>(DependencyInjectId.CourseApi)
    }

    public async getCourseDetail(id: number, lang: string): Promise<CourseDetailModel> {
        const courseResponse: CustomResponse<CourseDetailModel> = (await this.courseApi.getCourseDetail(id, lang)).data;
        return CourseHelper.mappingCourseDetail(courseResponse.data);
    }

    public async getCourseRecently(lang: string): Promise<CourseRecentlyResponse> {
        const courseResponse: CustomResponse<CourseRecentlyResponse> = (await this.courseApi.getCourseRecently(lang)).data;
        return CourseHelper.mappingCourseRecently(courseResponse.data);
    }

    public async getCourseMyList(isRecentCourse: boolean, lang: string): Promise<MyCourseListModel[]> {
        const courseResponse: CustomResponse<MyCourseListModel[]> = (await this.courseApi.getCourseMyList(isRecentCourse, lang)).data;
        return courseResponse.data.map((course) => CourseHelper.mappingCourseList(course));
    }

    public async startCourse(id: number): Promise<boolean> {
        const userResponseData: CustomResponse<boolean> = (await this.courseApi.startCourse(id)).data;
        return userResponseData.data;
    }

    public async finishedOnBoarding(): Promise<boolean> {
        const courseResponse: CustomResponse<boolean> = (await this.courseApi.finishedOnBoarding()).data;
        return courseResponse.data;
    }
}
